"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _capitalizeFirstWord = require("../../utilities/capitalizeFirstWord");
var _createSvg = _interopRequireWildcard(require("../../utilities/createSvg"));
var _BusbudPanel = _interopRequireDefault(require("./BusbudPanel.svg"));
var _LogoBusbud = require("./LogoBusbud.styles");
var _LogoBusbud2 = _interopRequireDefault(require("./LogoBusbud.svg"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SVG_VIEWBOX_DEFINITION = {
  default: {
    x: 0,
    y: 0,
    width: 439,
    height: 131
  },
  'symbol-only': {
    x: 0,
    y: 0,
    width: 96,
    height: 131
  },
  'contained-symbol': {
    x: 0,
    y: 0,
    width: 96,
    height: 131
  },
  'panel-only': {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  },
  'wordmark-only': {
    x: 125,
    y: 0,
    width: 314,
    height: 131
  }
};
const SIZE_HEIGHT_MAP = {
  xs: 24,
  sm: 36,
  md: 40
};
const SVG_ICONS = {
  BusbudPanel: {
    name: 'BusbudPanel',
    icon: _BusbudPanel.default,
    // width and height comes from the SVG file
    height: 64,
    width: 64
  },
  BusbudLogo: {
    name: 'LogoBusbud',
    icon: _LogoBusbud2.default,
    // width and height comes from the SVG file
    height: 131,
    width: 439
  }
};
const getWrapperSizeClassKey = size => {
  return `wrapper${(0, _capitalizeFirstWord.capitalizeFirstWord)(size)}`;
};
const SymbolWrapper = _ref => {
  let {
    children,
    className,
    size
  } = _ref;
  const {
    classes,
    cx
  } = (0, _LogoBusbud.useSymbolWrapperStyles)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cx(classes.wrapper, classes[getWrapperSizeClassKey(size)], className)
  }, children);
};
const LogoBusbud = /*#__PURE__*/_react.default.forwardRef(function LogoBusbud(props, ref) {
  const {
    className,
    inverted = false,
    size = 'md',
    variant = 'default'
  } = props;
  const {
    classes,
    cx
  } = (0, _LogoBusbud.useLogoStyles)();
  const commonSvgProps = {
    ref,
    role: 'img',
    'aria-label': 'Busbud.com',
    className: cx(classes.root, className, {
      [classes.inverted]: inverted
    })
  };
  const icon = variant === 'panel-only' ? SVG_ICONS.BusbudPanel : SVG_ICONS.BusbudLogo;
  const viewBoxDefinition = SVG_VIEWBOX_DEFINITION[variant];
  const height = SIZE_HEIGHT_MAP[size];
  const svgSizeRatio = height / icon.height;
  const width = viewBoxDefinition.width * svgSizeRatio;
  const Logo = (0, _createSvg.default)({
    inlineSvg: icon.icon,
    width,
    height,
    name: icon.name,
    path: `${_createSvg.externalBasePath}/BrandLogo/LogoBusbud/${icon.name}.svg#root`
  });
  const viewBox = `${viewBoxDefinition.x} ${viewBoxDefinition.y} ${viewBoxDefinition.width} ${viewBoxDefinition.height}`;
  const logoSvg = /*#__PURE__*/_react.default.createElement(Logo, (0, _extends2.default)({
    viewBox: viewBox
  }, commonSvgProps));
  if (variant === 'contained-symbol') {
    return /*#__PURE__*/_react.default.createElement(SymbolWrapper, {
      size: size
    }, logoSvg);
  }
  return logoSvg;
});
var _default = exports.default = LogoBusbud;